<div class="card" [ngClass]="{ 'container-fluid': mobileMode(), 'p-0': mobileMode() }"
  [style.background-color]="clozeTestStyleModel().exerciseBackground" [ngStyle]="{
        border: mobileMode() ? '0px' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0px' : '8px',
        width: mobileMode() ? '' : '720px',
      }">
  <div class="card-body d-flex flex-column justify-content-center align-items-center"
    [style.font-family]="clozeTestStyleModel().font" style="min-height: 200px; gap: 16px">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor"
      style="color: #e53e3e; flex-shrink: 0">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
    </svg>
    @if (lang().toLowerCase() === 'en') {
    <h4 class="mb-0 text-center font-weight-bold" style="font-size: 1.1rem">
      Access not possible
    </h4>
    <p class="mb-0 text-center" style="color: #555; max-width: 400px">
      Your access token is invalid or expired. Please check the link or contact support.
    </p>
    } @else {
    <h4 class="mb-0 text-center font-weight-bold" style="font-size: 1.1rem">
      Zugang nicht möglich
    </h4>
    <p class="mb-0 text-center" style="color: #555; max-width: 400px">
      Ihr Zugriffstoken ist ungültig oder abgelaufen. Bitte überprüfen Sie den Link oder wenden Sie sich an den Support.
    </p>
    }
  </div>
</div>